import { LocalPrintshopOutlined } from '@mui/icons-material'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, FormControl, Modal } from 'react-bootstrap'
import { getSalesOrderList, getWarehouseKeyValueList } from '../../../services'
import toast from 'react-hot-toast'
import { addSalesOrder, getSalesOrderListByWareHouse, multipleSalesOrder, multipleSalesSave } from '../../../services/Sales/SalesOrderService'
import { useReactToPrint } from 'react-to-print'
import Select from "react-select";
import { Input } from 'antd'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

const PickList = () => {
    const [pick, setPick] = useState(false)
    const [picklist, setPickList] = useState([])
    const [salesOrdersList, setSalesOrdersList] = useState([])
    const [index, setIndex] = useState(0);
    const [filterText, setFilterText] = useState("");
    const [salesOrderListDetails, setSalesOrderListDetails] = useState(null);
    const [multiBatch, setmultiBatch] = useState([])
    const [salesOrderFormat, setSalesOrderFormat] = useState([]);
    const [wareHouseOption, setWareHouseOptions] = useState([])
    const [selectedWare, setSelectedWare] = useState()


    // useEffect(() => {
    //     if(selectedWare?.value){
    //         getAllSalesOrders()
    //     }
    // }, [selectedWare])

    useEffect(() => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                let options = [];
                res.responsePacket?.map((d) => {
                    options.push({
                        value: d.key,
                        label: d.value,
                    });
                });
                setWareHouseOptions(options);
                setSelectedWare(options?.[0])
            } else {
                toast(res.message);
            }
        });
    }, [])


    const getAllSalesOrders = (e,filterText) => {
        let list_data = {
            page: 0,
            size: 15,
            search: filterText?filterText:"",
            uuid2: "",
            uuid: "",
            warehouseId: e?.value ? e?.value : selectedWare?.value
        };
        getSalesOrderListByWareHouse(list_data).then((res) => {
            if (res.errorCode === 0) {
                // res.responsePacket.data.reverse();
                if (index === 0) {
                    setSalesOrdersList(res.responsePacket.data);
                } else {
                    const salesOrdersListClone = [...res.responsePacket.data];
                    setSalesOrdersList(salesOrdersListClone);
                }
                setIndex(1);
                setSalesOrderListDetails({
                    recordsFiltered: res.responsePacket.recordsFiltered,
                    recordsTotal: res.responsePacket.recordsTotal,
                    total: res.responsePacket.total,
                })

            } else {
                toast(res.message);
            }
        });
    };
    const getAllSalesOrdersPage = (e) => {
        let list_data = {
            page: index,
            size: 15,
            search: filterText,
            uuid2: "",
            uuid: "",
            warehouseId: selectedWare?.value
        };
        getSalesOrderListByWareHouse(list_data).then((res) => {
            if (res.errorCode === 0) {
                // res.responsePacket.data.reverse();
                if (index === 0) {
                    setSalesOrdersList(res.responsePacket.data);
                } else {
                    const salesOrdersListClone = [...salesOrdersList, ...res.responsePacket.data];
                    setSalesOrdersList(salesOrdersListClone);
                }
                setIndex(index + 1);
                setSalesOrderListDetails({
                    recordsFiltered: res.responsePacket.recordsFiltered,
                    recordsTotal: res.responsePacket.recordsTotal,
                    total: res.responsePacket.total,
                })

            } else {
                toast(res.message);
            }
        });
    };


    const handleSalesOrderPick = (id) => {
        if (picklist.includes(id)) {
            setPickList((prev) => prev.filter(d => d != id))
        }
        else {
            setPickList((prev) => { return [...prev, id] })
        }
    }
    const handleMultipleSalesorder = async () => {
        let data = await multipleSalesOrder({ uuid: picklist });
        setSalesOrderFormat(data?.responsePacket);
        let finalbatchdetails = data?.responsePacket.reduce((acc, e) => acc.concat(e.items), [])?.reduce((acc, item) => {
            const { unit, quantity, salesOrderNo, itemTitle, batch } = item;

            const index = acc.findIndex(obj => obj.itemTitle === itemTitle);

            if (index !== -1) {
                if (acc[index].Quantity?.[unit]) {
                    acc[index].Quantity[unit] += quantity;
                } else {
                    acc[index].Quantity[unit] = quantity;
                }

                acc[index].salesOrderNoWithQty.push(`${salesOrderNo}(${quantity}-${unit})`);
                acc[index].salesOrderFields.push({
                    salesNo: `${salesOrderNo}(${quantity}-${unit})`, batchDetails: [{
                        batch: "",
                        quantity: ""
                    }]
                })
                acc[index].sales.push(`${salesOrderNo}`)

            } else {
                acc.push({
                    ...item,
                    Quantity: { [unit]: quantity },
                    salesOrderNoWithQty: [`${salesOrderNo}(${quantity}-${unit})`],
                    salesOrderFields: [
                        {
                            salesNo: `${salesOrderNo}(${quantity}-${unit})`,
                            batchDetails: [{
                                batch: "",
                                quantity: ""
                            }]

                        }
                    ],
                    sales: [`${salesOrderNo}`]
                });
            }
            return acc;
        }, []);

        setmultiBatch(finalbatchdetails);
        setPickList([]);
        setPick(false);
    };


    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => {// Trigger the print mode
            return componentRef.current;
        },
        documentTitle: "PickList",
        // pageStyle: "print",
    });

    const handleAddMoreField = (i, j) => {
        let newMultiBatch = [...multiBatch];
        let newSalesOrderFields = [...newMultiBatch[i].salesOrderFields];
        let newBatchDetails = [...newSalesOrderFields[j].batchDetails];
        newBatchDetails.push({ batch: "", quantity: "" });
        newSalesOrderFields[j] = { ...newSalesOrderFields[j], batchDetails: newBatchDetails };
        newMultiBatch[i] = { ...newMultiBatch[i], salesOrderFields: newSalesOrderFields };
        setmultiBatch(newMultiBatch);
    };

    const handleRemoveBatchDetails = (index, i, idx) => {
        let newMultiBatch = [...multiBatch];
        let newSalesOrderFields = [...newMultiBatch[index].salesOrderFields];
        let newBatchDetails = [...newSalesOrderFields[i].batchDetails];
        newBatchDetails.splice(idx, 1);
        newSalesOrderFields[i] = { ...newSalesOrderFields[i], batchDetails: newBatchDetails };
        newMultiBatch[index] = { ...newMultiBatch[index], salesOrderFields: newSalesOrderFields };
        setmultiBatch(newMultiBatch);
    };

    const handleSelectChange = (e, i, j, k) => {
        let newMultiBatch = [...multiBatch];
        let newSalesOrderFields = [...newMultiBatch[i].salesOrderFields];
        let newBatchDetails = [...newSalesOrderFields[j].batchDetails];

        newBatchDetails[k] = {
            ...newBatchDetails[k],
            batch: e
        };

        newSalesOrderFields[j] = {
            ...newSalesOrderFields[j],
            batchDetails: newBatchDetails
        };

        newMultiBatch[i] = {
            ...newMultiBatch[i],
            salesOrderFields: newSalesOrderFields
        };

        setmultiBatch(newMultiBatch);
    }

    const handleQuantityChange = (e, i, j, k) => {
        let newMultiBatch = [...multiBatch];
        let newSalesOrderFields = [...newMultiBatch[i].salesOrderFields];
        let newBatchDetails = [...newSalesOrderFields[j].batchDetails];
        newBatchDetails[k].quantity = e
        newMultiBatch[i] = { ...newMultiBatch[i], salesOrderFields: newSalesOrderFields };
        setmultiBatch(newMultiBatch);
    }


    const handleSubmit = async () => {
        let newSales = salesOrderFormat.map((sales) => {
            let prevItems = sales.items;
            let item = multiBatch.find((e) => e.sales?.includes(sales.orderNo))
            let ind = prevItems.findIndex(obj => obj.itemUuid === item.itemUuid)
            let newBatchInfo = item.salesOrderFields.find((e) => {
                const cleanedStr1 = e.salesNo.replace(/\(.*?\)/, '');
                const cleanedStr2 = sales.orderNo.replace(/\(.*?\)/, '');
                return cleanedStr1 === cleanedStr2;
            })
            item.batchInfo = newBatchInfo?.batchDetails
            prevItems[ind] = item;


            return { ...sales, items: prevItems }
        })
        // let data = await multipleSalesSave(newSales)
        // console.log("data", newSales)
    }
    const handleWareHouseSales = (e) => {
        setSalesOrdersList([])
        setSelectedWare(e)
        getAllSalesOrders(e)
    }
const handleSearch=(e)=>{
    setFilterText(e);
    getAllSalesOrders(selectedWare?.value,e)
}

    return (
        <div>
            <div className="header no-border d-flex align-items-center p-4">

                <h6 class="listTopHeading">
                </h6>

                <a
                    className="over-flow header-title text-uppercase"
                    style={{ fontSize: "x-large" }}
                >
                    &nbsp;
                </a>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
                    <Form.Label style={{ marginRight: "10px" }}>Select Warehouse:</Form.Label>
                    <Select
                        onChange={handleWareHouseSales}
                        options={wareHouseOption}
                        className="w-50"
                        styles={{
                            control: (base) => ({
                                ...base,
                                borderColor: '#ced4da',
                                boxShadow: 'none',
                                '&:hover': {
                                    borderColor: '#80bdff',
                                },
                                minWidth: "200px"
                            }),
                        }}
                    />
                </div>
                <div className="btn-group mr-2 pr-0 ml-3 mb-3">
                    <button
                        className="tooltip-container ember-view btn btn-primary print-btn m-0"
                        onClick={() => setPick(true)}
                    >
                        Multiple Sales order Pick List
                    </button>
                </div>
                <div className="btn-toolbar d-flex justify-content-end align-items-center">

                    <div className="btn-group mr-2 pr-0">
                        {multiBatch.length > 0 && <button
                            className="tooltip-container ember-view btn btn-primary print-btn m-0"
                            onClick={handlePrint}
                        >
                            <LocalPrintshopOutlined />
                        </button>}
                    </div>
                </div>
            </div>
            <br />
            <div ref={componentRef} >
                {multiBatch?.length > 0 ?
                    <table
                        style={{
                            width: '100%',
                            tableLayout: 'fixed',
                            clear: 'both',
                        }}
                        className='pcs-label'
                        id='itemTable'
                        cellSpacing={0}
                        cellPadding={0}
                        border='1px solid black'
                    >
                        <thead>
                            <tr>
                                <td style={{ width: '10%' }}>S.No.</td>
                                <td style={{ width: '100%', display: "flex", justifyContent: "space-between" }}><span style={{ marginLeft: "5px", width: "24%" }}>Item</span><span style={{ width: "22%" }}>Batches</span><span style={{ width: "15%", paddingLeft: "15px" }}>Total Qty</span><span style={{ width: "13%", marginLeft: "10px" }}>Select Qty</span></td>
                            </tr>

                        </thead>
                        <tbody >
                            {multiBatch.length > 0 && multiBatch?.map((item, index) => {
                                return (
                                    <tr style={{ marginLeft: "8px" }} key={index}>
                                        <td><div style={{ width: "100%", marginLeft: "20px" }}>{index + 1}</div></td>
                                        <td>
                                            <div style={{ marginLeft: "5px", marginRight: "5px", display: "flex", justifyContent: "space-between" }}><span style={{ width: "33%", textDecoration: "underline" }}>
                                                {item.itemTitle}<br />
                                            </span>

                                                <span style={{ width: "33%", display: "flex", flexWrap: "wrap" }}>
                                                    {item?.Quantity ? Object.entries(item?.Quantity).map(([key, value], index, array) => {
                                                        return (
                                                            <p
                                                                style={{
                                                                    textDecoration: "underline",
                                                                    margin: "0",
                                                                    display: "inline",
                                                                    marginRight: "5px"
                                                                }}
                                                                key={key}>
                                                                {value} <strong>{key}</strong>{index < array.length - 1 && '+'}
                                                            </p>
                                                        );
                                                    }) : (
                                                        <p style={{ margin: "0", display: "inline" }}>
                                                            {item.quantity}<strong>{item.unit}</strong>
                                                        </p>
                                                    )}
                                                </span>

                                            </div>
                                            <div style={{ width: '100%', marginTop: '10px' }} className='pcs-label'>
                                                {item?.salesOrderFields?.map((e, i) => {
                                                    const batchOptions = item?.beanInvoiceBatchesList?.map((d) => {
                                                        return {
                                                            ...d, label:
                                                                <div>
                                                                    <div style={{ marginBottom: '4px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                                                        <p style={{ fontWeight: 'bold', marginRight: '8px' }}>
                                                                            {`${d?.batchNumber} (${d?.batchQuantity}-${d?.unitTitle ? d?.unitTitle : item?.packUnit})`}
                                                                        </p>
                                                                        <span style={{ fontWeight: 'normal', marginRight: '8px' }}>{d?.batchExpiredDate}</span>
                                                                        <span style={{ fontWeight: 'normal', marginRight: '8px' }}>{d?.storeTitle}</span>
                                                                        <span style={{ fontWeight: 'normal', marginRight: '8px' }}>{d?.rackTitle}</span>
                                                                        <span style={{ fontWeight: 'normal', marginRight: '8px' }}>{d?.cellTitle}</span>
                                                                        <span style={{ fontWeight: 'normal' }}>{d?.palletTitle}</span>
                                                                    </div>
                                                                </div>,
                                                            value: `${d?.batchNumber}-${d?.batchExpiredDate}-${d?.storeTitle}-${d?.rackTitle}-${d?.cellTitle}-${d?.palletTitle}`
                                                        }
                                                    })
                                                    return (
                                                        <div key={i} style={{ display: 'flex', flexDirection: 'row' }}>
                                                            <div style={{ flex: 1, display: 'flex', marginTop: "0px" }}>
                                                                <div style={{ display: "flex", marginLeft: "100px" }}>{e.salesNo}<div className='print-hide'><Button style={{ marginLeft: "10px" }} onClick={() => handleAddMoreField(index, i)} size='sm'>Add More+</Button></div></div>
                                                            </div>
                                                            <div style={{ flex: 2 }}>
                                                                {e?.batchDetails && e.batchDetails?.map((data, idx) => {
                                                                    return (
                                                                        <div key={idx} style={{ display: 'flex', width: "100%", marginBottom: '3px', justifyContent: "space-between" }}>
                                                                            <div style={{ width: "78%" }}>
                                                                                <Select
                                                                                    classNamePrefix="custom-select"
                                                                                    options={batchOptions}
                                                                                    onChange={(e) => handleSelectChange(e, index, i, idx)}
                                                                                    value={data?.batch}
                                                                                />
                                                                            </div>
                                                                            <div style={{ width: "20%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                                                <FormControl
                                                                                    className='hide-input' style={{
                                                                                        width: "50%"
                                                                                    }} value={data?.quantity == "" ? e.quantity : data?.quantity} onChange={(e) => handleQuantityChange(e.target.value, index, i, idx)}  >
                                                                                </FormControl>
                                                                                <div className='print-hide'><Button onClick={() => handleRemoveBatchDetails(index, i, idx)} size="sm" style={{ padding: "0 8px" }}>
                                                                                    X
                                                                                </Button></div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table> : <div style={{ marginLeft: "30px" }}>Select Sales Order to get PickList</div>}
                {/* <div className='print-hide' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>{multiBatch.length > 0 && <Button onClick={handleSubmit}>Save</Button>}</div> */}
            </div>

            <Modal show={pick} onHide={() => setPick(false)} size="lg">
                <Modal.Header>
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <h1>Select Sales Order{`(${picklist.length})`}</h1>
                        {/* <input autoComplete="off" className="form-control" type="text" placeholder="Search..." onChange={(e)=>handleSearch(e.target.value)} ></input> */}
                        <div style={{width:"200px "}} className="input-group paginationSearchInput listSearch">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">
                                        <SearchRoundedIcon />
                                    </span>
                                </div>
                                <input autoComplete="off" className="form-control" type="text" placeholder="Search..." value={filterText} onChange={(e)=>handleSearch(e.target.value)}/>
                            </div>
                        <Button
                            variant="primary"
                            onClick={handleMultipleSalesorder}
                        >
                            Submit
                        </Button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div
                        className="ember-view scroll-y noscroll-x fill body scrollbox"
                    >
                        <div className="table-responsive overflow-initial ">
                            <table
                                id="ember7912"
                                className="table zi-table ember-view header-fixed"
                            >
                                {salesOrdersList && (salesOrdersList.length > 0 ?
                                    (<tbody>
                                        {salesOrdersList.map((d, i) => (
                                            <tr
                                                key={i}
                                                className={`listTr ${picklist.includes(d.recordId)
                                                    ? "activeRecord"
                                                    : ""
                                                    }`}
                                                onClick={() => handleSalesOrderPick(d?.recordId)}
                                            >
                                                <td>
                                                    <span className="titleTr">
                                                        {d.customerTitle}
                                                    </span>
                                                    <span className="d-flex justify-content-between">
                                                        <span>{d.orderNo}</span>
                                                        <span>₹{" "}{d.totalAmount?.toFixed(2)}</span>
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                        {
                                            salesOrderListDetails &&
                                            salesOrderListDetails.recordsTotal >
                                            salesOrdersList.length && (
                                                <div className="pt-3">
                                                    <button
                                                        className="btn mx-auto newListBtn"
                                                        onClick={getAllSalesOrdersPage}
                                                    >
                                                        Load More
                                                    </button>
                                                </div>

                                            )}
                                    </tbody>) : (<div className="my-3 text-black text-center">No Data Available!</div>)
                                )}
                            </table>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default PickList